import React from 'react'

const ArrowDecrement = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_2596_7778)">
    <path d="M10.6667 11.333H14.6667V7.33301" stroke="#FF3B30" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.6666 11.3337L8.99992 5.66699L5.66659 9.00033L1.33325 4.66699" stroke="#FF3B30" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_2596_7778">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
  )
}

export default ArrowDecrement